<div class="app-onboarding__header-and-content">
  <div class="app-onboarding__header">
    <actee-modal-stepper
      [totalSteps]="totalSteps"
      [(currentStep)]="currentStep"
    />
  </div>

  <div class="app-onboarding__content">
    @switch (currentStep()) {
      @case (1) {
        <app-onboarding-step-one />
      }
      @case (2) {
        <app-onboarding-step-two />
      }
      @case (3) {
        <app-onboarding-step-three />
      }
      @case (4) {
        <app-onboarding-step-four />
      }
    }
  </div>
</div>
<div class="app-onboarding__separator"></div>
<div class="app-onboarding__footer">
  @if (!isFirstStep()) {
    <button
      acteeButton
      type="button"
      variant="tertiary"
      size="medium"
      (click)="goToPreviousSlide()"
    >
      {{ 'onboarding.actionsButton.previous' | translate }}
    </button>
  }

  <div class="app-onboarding__footer-right">
    @if (!isLastStep()) {
      <button
        acteeButton
        type="button"
        variant="secondary"
        (click)="skipOnboardingTutorial()"
      >
        {{ 'onboarding.actionsButton.skip' | translate }}
      </button>

      <button
        acteeButton
        type="button"
        variant="primary"
        size="medium"
        (click)="goToNextSlide()"
      >
        {{ 'onboarding.actionsButton.next' | translate }}
      </button>
    } @else {
      <button
        acteeButton
        type="button"
        variant="primary"
        size="medium"
        (click)="completeOnboardingTutorial()"
      >
        {{ 'onboarding.actionsButton.confirmed' | translate }}
      </button>
    }
  </div>
</div>
